
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tjenester",
      function () {
        return require("private-next-pages/tjenester.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tjenester"])
      });
    }
  